export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1627518788331-b3b7fdaa382f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  testimonial: "https://images.pexels.com/photos/8112186/pexels-photo-8112186.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

export const NAV_LINKS = [
  { href: "/#servicios", label: "Servicios" },
  { href: "/#historia", label: "Nuestra Historia" },
  { href: "/#membresias", label: "Membresías & Timeshare" },
  { href: "/#testimonios", label: "Testimonios" },
  { href: "/#contacto", label: "Contacto" },
];

export const FIGURES = [
  { value: "15+", label: "Años de trayectoria" },
  { value: "500+", label: "Casos resueltos" },
  { value: "100%", label: "Español & inglés" },
];

export const SERVICIOS = [
  {
    num: "I.",
    slug: "derecho-civil",
    title: "Derecho Civil",
    text: "Contratos, responsabilidad civil, controversias patrimoniales y representación en juicios civiles con estrategia clara desde la primera consulta.",
  },
  {
    num: "II.",
    slug: "derecho-mercantil",
    title: "Derecho Mercantil",
    text: "Constitución de sociedades, contratos comerciales, cobranza y litigio mercantil para negocios que operan en un mercado turístico exigente.",
  },
  {
    num: "III.",
    slug: "derecho-inmobiliario",
    title: "Derecho Inmobiliario",
    text: "Compraventa, fideicomisos costeros, due diligence de propiedad y resolución de conflictos para extranjeros y nacionales que invierten en la zona.",
  },
  {
    num: "IV.",
    slug: "derecho-familiar",
    title: "Derecho Familiar",
    text: "Divorcios, pensiones alimenticias, custodia y sucesiones, con un acompañamiento humano en momentos que requieren sensibilidad y firmeza.",
  },
  {
    num: "V.",
    slug: "derecho-corporativo",
    title: "Derecho Corporativo",
    text: "Gobierno corporativo, cumplimiento normativo y asesoría continua para empresas en crecimiento dentro y fuera de la industria turística.",
  },
];

export const PASOS = [
  {
    num: "1",
    title: "Consulta y revisión inicial",
    text: "Analizamos tu contrato y el historial de pagos sin costo, para darte un panorama honesto de tus opciones.",
  },
  {
    num: "2",
    title: "Identificación de irregularidades",
    text: "Detectamos cláusulas abusivas, vicios en el consentimiento o incumplimientos de la empresa vendedora.",
  },
  {
    num: "3",
    title: "Estrategia legal a la medida",
    text: "Definimos la vía más efectiva: negociación directa, reclamación formal o litigio, según tu caso.",
  },
  {
    num: "4",
    title: "Resolución y seguimiento",
    text: "Te acompañamos hasta obtener la cancelación formal, con toda la documentación en regla.",
  },
];

export const TIPOS_MEMBRESIA = [
  "Tiempo compartido (Timeshare)",
  "Club vacacional",
  "Membresía de puntos",
  "Fraccional / semanas fijas",
  "Otro",
];

export const TESTIMONIOS = [
  {
    quote:
      "\"Llevábamos tres años pagando una membresía que ya no usábamos. El equipo de Contreras nos explicó todo con claridad y logramos la cancelación en pocos meses.\"",
    name: "Roberto & Elena M.",
    role: "Cancelación de timeshare · Nuevo Vallarta",
  },
  {
    quote:
      "\"Trato profesional de principio a fin. Nos ayudaron a estructurar la sociedad correctamente y siguen siendo nuestros asesores de cabecera.\"",
    name: "Constructora del Pacífico S.A.",
    role: "Derecho corporativo · Puerto Vallarta",
  },
  {
    quote:
      "\"En un momento difícil de mi divorcio, sentí un acompañamiento genuino y una defensa firme de mis derechos. Muy agradecida con todo el equipo.\"",
    name: "Carla R.",
    role: "Derecho familiar · Bucerías",
  },
];

export const CONTACTO = [
  { label: "Oficina", value: "C. Mina 314, Centro, 48300 Puerto Vallarta, Jal., México" },
  { label: "Teléfono", value: "+52 33 4624 0169" },
  { label: "Correo principal", value: "contrerasasociados86@gmail.com" },
  { label: "Correo alternativo", value: "info@contrerasasociados.online" },
  { label: "Horario", value: "Lunes a viernes, 9:00 – 18:00" },
];
